<span
  class="nsm-label"
  [class.info]="info"
  [class.warn]="warn"
  [class.danger]="danger"
  [class.success]="success"
>
  <ng-content></ng-content>
</span>
